import React from "react";
import "./ComparteYGana.css";
import errorImage from "../assets/error.jpeg";

const ComparteYGana = () => {
  return (
    <div className="comparti-gana-container">
      <div className="overlay">
        <h1>ESTAMOS CONSTRUYENDO ESTA SECCIÓN, ESTARÁ LISTA MUY PRONTO</h1>
      </div>
    </div>
  );
};

export default ComparteYGana;
